import { createContext, useContext } from 'react';
import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

const InsideCampaignLayout = createContext(false);

/**
 * Campaign-owned structural outlet, not another theme or painted workspace.
 * The host app keeps its original background, spacing and typography. This also
 * leaves the restored Settings page untouched when nested below the outlet.
 */
export function CampaignSurface({ children }) {
  const inside = useContext(InsideCampaignLayout);
  if (inside) return children;

  return (
    <InsideCampaignLayout.Provider value>
      <Box minW={0} w='100%'>
        {children}
      </Box>
    </InsideCampaignLayout.Provider>
  );
}

export default function CampaignOutlet() {
  return <CampaignSurface><Outlet /></CampaignSurface>;
}
